import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Rate, Row, Col, Typography } from "antd";
import moment from "moment";
import { Button, ReviewItem } from "@/components";
import { useStores } from "@/store";
import { useMemo } from "react";
import Gallery from "react-bnb-gallery";

/**评分&评论 */
export const Review = ({ id, reviews, reviews_count, reviews_ratings }) => {
  const { t } = useTranslation();
  const { dealStore } = useStores();
  const [page, setPage] = useState(1);
  const [photoList, setPhotoList] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [realLoad, setRealLoad] = useState(false);
  const [reviewList, setReviewList] = useState([]);
  const showMore = useMemo(() => {
    return reviews_count > 1 && reviewList.length < reviews_count;
  }, [reviews_count, reviewList]);

  useEffect(() => {
    setReviewList([reviews[0]]);
  }, []);

  async function onLoadMore() {
    setLoading(true);
    if (realLoad) {
      let list = reviewList.slice();
      let data = await dealStore.getReviews(id, page);
      list = list.concat(data);
      setPage(page++);
      setReviewList(list);
    } else {
      setRealLoad(true);
      setReviewList(reviews);
    }
    setLoading(false);
  }

  function onPreview(index, photos) {
    setPhotoList(photos.map(i => ({ photo: i.image_url })))
    setShow(true)
  }

  return (
    <section className="page-deal--review">
      <h3>{t("WEB.Reviews", { count: reviews_count })}</h3>
      <div className="review-rate">
        <Rate count={5} value={reviews_ratings.ratings_avg / 2} disabled />
      </div>
      <div className="review-rate-desc">
        <span>
          {t("WEB.Food")}: {reviews_ratings.cuisine_avg}
        </span>
        <span>
          {t("WEB.Service")}: {reviews_ratings.service_avg}
        </span>
        <span>
          {t("WEB.Decoration")}: {reviews_ratings.atmosphere_avg}
        </span>
      </div>
      {reviewList.map((item, index) => {
        return <ReviewItem
          review={item}
          key={item.id + '_' + index}
          onPreview={onPreview}
          hideMore={true}
          footer={false}
        />;
      })}
      {showMore && (
        <Button type="primary" block onClick={onLoadMore} loading={loading} >
          {t("WEB.Show more reviews")}
        </Button>
      )}
      <Gallery
        onClose={() => setShow(false)}
        photos={photoList}
        show={show}
        showThumbnails={false}
      ></Gallery>
      <div className="hairline-bottom-new" style={{ paddingBottom: '20px' }} ></div>
    </section>
  );
};
